import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '../../../assets/icons/Check.svg';
import {
  TestPassLetter, TestPassNumber, TestPassChar, specialCharList,
} from '../../../utils/formValidation';

const PasswordValidation = (password) => {
  const { t } = useTranslation();

  return (
    <div className="validation">
      <p>
        {password?.password.length > 7 && password?.password.length < 30
        && (<span><img src={CheckIcon} alt="Check" /></span>)}
        {' '}
        {t('Password_Char')}
      </p>
      <p>
        { TestPassLetter(password?.password) && (<span><img src={CheckIcon} alt="Check" /></span>)}
        {' '}
        {t('Password_Upper_Lower')}
      </p>
      <p>
        { TestPassNumber(password?.password) && (<span><img src={CheckIcon} alt="Check" /></span>)}
        {' '}
        {t('Password_Number')}
      </p>
      <p>
        { TestPassChar(password?.password) && (<span><img src={CheckIcon} alt="Check" /></span>)}
        {' '}
        {`${t('Password_Special_Char')} ${specialCharList}`}
      </p>
      <p>
        {password?.password && (password?.password === password?.verifiedPassword)
        && (<span><img src={CheckIcon} alt="Check" /></span>)}
        {' '}
        {t('Password_equality')}
      </p>
    </div>
  );
};

export { PasswordValidation };
